export const WEBVIEW_GO_TO = {
  MAP: 'map',
  ANTIFRAUD_WEBVIEW: 'AntifraudWebview'
}